/**
 * TokenPush
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Motorista} from '@/model/resource/Motorista'
import {TokenPushCollection} from '@/model/collection/TokenPushCollection'

/* TODO: review generated class */
export class TokenPush extends Resource {
  idTokenPushPk: number = 0

  @ResponseSerialize(Motorista)
  motorista: Motorista | null = null

  token: string | null = null

  modeloAparelho: string | null = null
  marcaAparelho: string | null = null

  get $id() {
    return this.idTokenPushPk
  }
  set $id(val) {
    this.idTokenPushPk = val
  }

  get idMotoristaFk() {
    if (!this.motorista) return 0
    return this.motorista.$id
  }
  set idMotoristaFk(val) {
    if (!this.motorista) this.motorista = new Motorista()
    this.motorista.$id = val
  }

  /**
   * Gets a instance of a given ID of TokenPush
   */
  async getTokenPush(id: number) {
    return await Request.get(`/admin/token-push/${id}`)
      .name('getTokenPush')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of TokenPush
   */
  static async listTokenPush(params: any) {
    return await Request.get(`/admin/token-push`, {params})
      .name('listTokenPush')
      .as(TokenPushCollection)
      .getData()
  }

  /**
   * Persists a new instance of TokenPush. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistTokenPush() {
    return await Request.post(`/admin/token-push`, this)
      .name('persistTokenPush')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of TokenPush to use it in a CSV file
   */
  static async listCsvTokenPush(params: any) {
    return await Request.get(`/admin/token-push/csv`, {params})
      .name('listCsvTokenPush')
      .as(TokenPushCollection)
      .getData()
  }
}
